import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Page } from './Page';
import { MonthParams } from './types';
import { LoadingPage } from '@/pages';
import { useProfile } from '@/hooks';

export function PageWrapper() {
  const { year, month } = useParams<MonthParams>();
  const { manager } = useProfile();

  if (!manager.rechte.tagebuch) {
    return <Navigate to={'/'} />;
  }

  return (
    <Suspense key={month + '-' + year} fallback={<LoadingPage />}>
      <div className="flex flex-col gap-8 py-10 px-10 w-screen 2xl:max-w-screen-2xl 2xl:mx-auto">
        <Page />
      </div>
    </Suspense>
  );
}
